import countries from 'i18n-iso-countries';
import ruLocale from 'i18n-iso-countries/langs/ru.json';

// Регистрируем русскую локализацию
countries.registerLocale(ruLocale);

// Функция для получения полного названия страны по коду
export const getCountryName = (countryCode) => {
  if (!countryCode) return 'Неизвестно';
  if (countryCode === 'DEV') return 'Локальная среда';
  
  try {
    // Проверяем, что код страны в правильном формате (2 символа)
    if (countryCode && countryCode.length === 2) {
      const countryName = countries.getName(countryCode.toUpperCase(), 'ru');
      if (countryName) {
        return countryName;
      }
    }
    
    // Если не удалось получить название, возвращаем код
    console.log('Не удалось получить название страны для кода:', countryCode);
    return countryCode;
  } catch (error) {
    console.error('Ошибка при получении названия страны:', error);
    return countryCode;
  }
};

export default {
  getCountryName
};
